export const DUTY_PLANNER_DATA_RECEIVED = 'duty-planner/DUTY_PLANNER_DATA_RECEIVED';
